import { Box, Stack, Typography } from '@mui/material';
import * as React from 'react';
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import 'swiper/css/effect-fade';
import { Autoplay, EffectFade } from 'swiper/modules';
import { settingActions, settingObj } from '../../store/SettingSlice';
import { getImgPath } from '../../store/JSTool';


export default function HomePosterView() {

    const [swp, setSwp] = React.useState(null);
    const pageNum = [0, 1, 2, 3];
    const [index, setIndex] = React.useState(0);

    function leftTap() {
        if (swp) {
            swp.slidePrev();
        }
    }

    function rightTap() {
        if (swp) {
            swp.slideNext();
        }
    }

    function indexChanged() {
        if (swp) {
            setIndex(swp.realIndex);
        }
    }

    function pageTap(i) {
        console.log(i);
        if (swp) {
            swp.slideToLoop(i);
        }
    }

    return (
        <Stack sx={{
            width: 1,
            height: '100vh',
            minHeight: '100vh',
            position: 'relative',
        }}>
            <Swiper style={{
                height: '100%',
                width: '100%'
            }}
                effect={'fade'}
                loop={true}
                slidesPerView={1}
                modules={[Autoplay, EffectFade]}
                centeredSlides={true}
                slideToClickedSlide={true}

                autoplay={{
                    delay: 6000,
                    disableOnInteraction: false,
                }}

                onActiveIndexChange={(sp) => {
                    indexChanged();
                }}

                onSwiper={(swiper) => {
                    setSwp(swiper);
                }}>

                <SwiperSlide ><PosterVideo imgUrl='https://game-cdn.aplusjapan-game.com/sfd_web/images/vbg.jpg' videoUrl='https://game-cdn.aplusjapan-game.com/sfd_web/images/video_all.mp4' /></SwiperSlide>
                <SwiperSlide ><PosterVideo imgUrl={getImgPath('game/opm_img2.png')} videoUrl={getImgPath('game/opm_video.mp4')} /></SwiperSlide>
                <SwiperSlide ><PosterItem imgName='poster_0.jpg' /></SwiperSlide>
                <SwiperSlide ><PosterItem imgName='poster_4.jpg' /></SwiperSlide>
            </Swiper>

            {/* Mask */}
            <SwiperMask leftTap={leftTap} rightTap={rightTap} />
            <PageItem pageNum={pageNum} currentIndex={index} pageTap={pageTap} />

        </Stack>
    );
}

function PageItem(props) {
    return (
        <Stack sx={{
            position: 'absolute',
            zIndex: 10,
            width: 1,
            bottom: 0,
            height: '60px',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
        }}>

            {props.pageNum.map((v, i) => {
                return <Box
                    key={v}
                    onClick={() => {
                        props.pageTap(i);
                    }}
                    sx={{
                        cursor: 'pointer',
                        mx: 1,
                        width: props.currentIndex == i ? '40px' : '20px',
                        height: '8px',
                        borderRadius: '4px',
                        bgcolor: props.currentIndex == i ? '#ffffff' : '#99999999',
                    }} />
            })}
        </Stack>
    )
}

function PosterItem(props) {
    return (
        <Stack sx={{
            width: 1,
            height: 1,
            bgcolor: 'black',
        }}>
            <Box
                component={'img'}
                src={getImgPath(props.imgName)}
                sx={{
                    width: 1,
                    height: 1,
                    objectFit: 'cover',
                    opacity: 0.5
                }} />
        </Stack>
    );
}

function PosterVideo(props) {
    return (
        <Stack sx={{
            width: 1,
            height: 1,
            bgcolor: 'black',
        }}>
            <Box
                component={'video'}
                autoPlay={true}
                loop={true}
                muted={true}
                poster={props.imgUrl}
                src={props.videoUrl}
                sx={{
                    width: 1,
                    height: 1,
                    objectFit: 'cover',
                    opacity: 0.5
                }} />
        </Stack>
    );
}

function SwiperMask(props) {
    return (
        <Stack sx={{
            position: 'absolute',
            width: 1,
            height: 1,
            zIndex: 2,
            justifyContent: 'center',
            alignItems: 'center',
        }}>

            <Stack sx={{
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',
                width: 1,
            }}>
                <Box
                    onClick={props.leftTap}
                    component={'img'}
                    src={getImgPath('arrow_left2.png')}
                    sx={{
                        height: '33px',
                        mx: 10,
                        cursor: 'pointer',
                        transitionDuration: '0.3s',
                        '&:hover': {
                            transform: 'scale(1.2)',
                        }
                    }} />

                <Stack sx={{
                    flex: 1,
                    maxWidth: '1800px',
                }}>
                    <ColorTextView index={0} whiteStr='WORLDWIDE' colorStr='PLAY' />
                    <ColorTextView index={1} whiteStr='BOUNDLESS' colorStr='JOY' end={true} />
                </Stack>

                <Box
                    onClick={props.rightTap}
                    component={'img'}
                    src={getImgPath('arrow_right2.png')}
                    sx={{
                        height: '33px',
                        mx: 10,
                        cursor: 'pointer',
                        transitionDuration: '0.3s',
                        '&:hover': {
                            transform: 'scale(1.2)',
                        }
                    }} />
            </Stack>

            {/* 底部渐变色 */}
            <Box sx={{
                width: 1,
                height: '80px',
                background: 'linear-gradient(#00000000 , #000000 )',
                position: 'absolute',
                bottom: 0,
            }} />
        </Stack>
    );
}

function ColorTextView(props) {

    const [showAni, setShowAni] = React.useState(false);

    React.useEffect(() => {
        setTimeout(() => {
            setShowAni(true);
        }, 2500);
    }, [])

    return (
        <Stack sx={{
            opacity: settingObj.showLogoAni ? 0 : 1,
            flexDirection: 'row',
            justifyContent: props.end ? 'end' : 'start',
            animation: ((showAni && settingObj.showLogoAni) && (props.index == 0 ? 'leftAni10 1.5s ease-in-out forwards' : 'rightAni10 1.5s ease-in-out forwards')),
        }}>
            <Typography sx={{
                lineHeight: '100px',
                color: 'white',
                fontFamily: 'Lexend Deca',
                fontSize: 85,
            }}>
                {props.whiteStr}
            </Typography>

            <Typography sx={{
                lineHeight: '100px',
                color: '#FFA129',
                fontFamily: 'Lexend Deca',
                fontSize: 85,
                ml: 5,
            }}>
                {props.colorStr}
            </Typography>
        </Stack>
    );
}

